<app-data-table-container class="max-h-[calc(52px*5)] border border-gray-200">
  <table mat-table [dataSource]="dataSource()">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Naam</th>
      <td mat-cell *matCellDef="let element">
        <span
          class="w-min max-w-40 truncate block"
          [matTooltip]="element.label"
          matTooltipPosition="after"
          >{{ element.label }}</span
        >
      </td>
    </ng-container>

    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef>Geschatte duratie</th>
      <td mat-cell *matCellDef="let element">
        {{ element.estimatedDuration | secondsToDuration }}
      </td>
    </ng-container>

    <ng-container matColumnDef="version">
      <th mat-header-cell *matHeaderCellDef>Versie</th>
      <td mat-cell *matCellDef="let element">
        <span
          class="bg-gray-300 text-gray-800 py-1 px-2 rounded-full text-xs font-medium"
        >
          v{{ element.version }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div>
          @if (!hideFlowButton()) {
            <button
              mat-icon-button
              matTooltip="Bekijk flow"
              (click)="openFlowView(element)"
            >
              <mat-icon>account_tree</mat-icon>
            </button>
          }
          @if (!hideActions()) {
            <button mat-icon-button (click)="itemRemove.emit(element.linkId)">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"
      class="whitespace-nowrap"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="hover:!bg-gray-100 whitespace-nowrap"
    ></tr>

    <tr class="mat-mdc-row" *matNoDataRow>
      <td
        class="mat-mdc-cell mdc-data-table__cell !border-none"
        [colSpan]="displayedColumns.length"
      >
        Geen resultaten gevonden
      </td>
    </tr>
  </table>
</app-data-table-container>
